import React from 'react';
import i18next from 'i18next';
import { initReactI18next, useTranslation, Trans as I18nextTrans } from 'react-i18next';
import { DEBUG_TRANS } from 'base/config/constant';
import { getParamsInSearch } from 'ava-util/dist/request';
import { useStoreState } from 'base/store';
import { merge } from 'ava-util/dist/data';
import enDev from 'base/locales/en';
import en from 'app/locales/en.json';
import de from 'app/locales/de.json';

// 是否开启本地开发调试模式，为 true 时读取 base/locales/en.ts 中的内容，为 false 读取数据库生成的 en.json 文件
const DEBUG_DEVELOPMENT = true;

// 创建 i18n 实例
export const i18nextInstance = i18next.createInstance();
// 注入插件，initReactI18next 是一个 3rdParty 类型的插件，也就是把实例给第三方插件，让其完全可以获取 i18n 实例所有信息
i18nextInstance.use(initReactI18next);

function mergeTranslation(staticTranslation: Record<string, string>, storeTranslation?: Record<string, string>) {
    return {
        translation: DEBUG_DEVELOPMENT && process.env.NODE_ENV === 'development'
            ? enDev
            : merge(staticTranslation, storeTranslation || {})
    }
}

// i18nextInstance.init 提取到 initI18next 函数中进行
export const initI18next = (lang: string, storeTranslation?: Record<string, Record<string, string>>) => {
    i18nextInstance.init(
        {
            lng: lang,
            fallbackLng: 'en',
            resources: {
                en: mergeTranslation(en, storeTranslation?.en),
                de: mergeTranslation(de, storeTranslation?.de),
            },
            react: {
                transSupportBasicHtmlNodes: true,
            }
        },
        (err) => {
            if (err) return console.log("something went wrong loading", err);
        }
    );
};

// 改变语言
export const changeI18nLang = (lang: string) => {
    i18nextInstance.changeLanguage(lang);
};

export type ITransInstance = {
    t: (code: string, config?: Record<string, any>) => string;
}

export const useTrans = (): ITransInstance => {
    const origin = useTranslation();
    const { debugTrans } = useStoreState('rootStore');
    if (debugTrans === '1') {
        return {
            t: (code: string, config?: Record<string, any>) => {
                return !!code ? `[${code}]${origin.t(code, config)}` : ''
            }
        };
    }
    if (debugTrans === '2') {
        return {
            t: (code: string, config?: Record<string, any>) => code
        }
    }
    return origin;
}

export const Trans: React.FC<{ i18nKey: string; values?: Record<string, any>; components?: Record<string, any> }> = props => {
    const { debugTrans } = useStoreState('rootStore');

    if (debugTrans === '1') {
        return (
            <>
                [{props.i18nKey}]
                <I18nextTrans {...props}/>
            </>
        )
    }
    if (debugTrans === '2') {
        return <>{props.i18nKey}</>;
    }
    // @ts-ignore
    return <I18nextTrans {...props}/>
}

export function ct(key: string) {
    let query = typeof window === 'undefined' ? {} : getParamsInSearch();

    if (query[DEBUG_TRANS] !== '1') {
        return i18nextInstance.t(key);
    }

    return key;
}